import { useState } from 'react';
import styles from './styles';

const PcModelOptionTagDebugger = ({
  variant_id,
  tags: [attrTags, reqTags, aggrReqTags, presentationTags],
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <>
      <button type="button" onClick={() => setIsExpanded(!isExpanded)}>
        {isExpanded ? 'Hide tags' : 'Show tags'}
      </button>

      {isExpanded && (
        <div className="tag-debugger">
          <p>Variant ID: {variant_id}</p>
          <p>Attribute Tags:</p>
          <pre>{JSON.stringify(attrTags, null, 2)}</pre>
          <p>Requirement Tags:</p>
          <pre>{JSON.stringify(reqTags, null, 2)}</pre>
          <p>Aggr Requirement Tags:</p>
          <pre>{JSON.stringify(aggrReqTags, null, 2)}</pre>
          <p>Presentation Tags:</p>
          <pre>{JSON.stringify(presentationTags, null, 2)}</pre>
        </div>
      )}

      <style jsx>{styles}</style>
    </>
  );
};

export default PcModelOptionTagDebugger;
